// import { mouseEvent } from "../common/mouse_event";
import BookItem from "../common/bookItem";
import AppRenderer from "../../app_renderer";
import BookData from "../../book_data";
import EventBus from "../../event_bus";
import { mouseEvent } from "../common/mouse_event";
import { store } from "../../../store";
import { VIEW_TYPE } from "../../view_type";
import { OUT_OPEN_TYPE } from "../common/bookItemDefine";
import Visibility from "../common/visibility";
import SystemData from "../../system_data";

//等待中
export default class OutOpen extends BookItem {
    outOpenType = OUT_OPEN_TYPE.FOLDER;

    weblinkRule = new RegExp('^http(?:' + ':' + '|s:)');
    fileRule = /\.[^a-z]+$/;
    audioRule = /\.(?:mp3)$/;
    videoRule = /\.(?:mp4)$/;

    /**
     *
     * @type {Visibility}
     * @memberof JumpPage
     */
    visibilityComponent = null;

    constructor(el, target) {
        super(el, target);
        this.path = this.el.path;
        this.connectNumber = this.el.connectNumber;
        // mouseEvent.add_mouse_event(this);
        this.add_mouse_event();
        this.setOutOpenType();


    }

    init() {
        this.target.gotoAndStop(0);//初始化影格
        // if (this.connectNumber != "" && this.itemControl.checkItemParent(this.target)) {
        //     this.target.visible = false;
        // }
        this.target.visible = false;
        mouseEvent.add_mouse_event(this);
        this.itemControl.loader.singleAntialiasing(this.target);
        this.visibilityComponent = new Visibility(this.target, this, this.itemControl);
    }

    start() {
        this.visibilityComponent.setVisibleByGroup();
        this.diffVerProcess();
    }

    diffVerProcess() {
        if (store.nowView == VIEW_TYPE.WEB && this.outOpenType != OUT_OPEN_TYPE.WEB_LINK && this.outOpenType != OUT_OPEN_TYPE.FILE) {
            this.target.visible = false;
        }
        if (SystemData.Instance.getPlatform() == 'darwin' && (this.path.slice(-3) == 'exe' || this.path.slice(-3) == 'flv')) {
            this.target.visible = false;
        }
        if ((store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) && this.outOpenType != OUT_OPEN_TYPE.WEB_LINK) {
            this.target.visible = false;
        }
    }

    trigger() {
        self = this;
        console.log("self.path", self.path);
        // this.target.gotoAndStop(0);//回歸初始影格

        switch (this.outOpenType) {
            case OUT_OPEN_TYPE.FILE:
            case OUT_OPEN_TYPE.AUDIO:
            case OUT_OPEN_TYPE.VIDEO:
            case OUT_OPEN_TYPE.FOLDER:
                if (SystemData.Instance.getPlatform() == 'darwin') {
                    let path = BookData.Instance.getBookPath() + self.path;
                    let newPath = SystemData.Instance.changePathToMac(path);
                    AppRenderer.Instance.openFile(newPath);
                } else {
                    AppRenderer.Instance.openFile(BookData.Instance.getBookPath() + self.path);
                }
                break;
            case OUT_OPEN_TYPE.WEB_LINK:
                AppRenderer.Instance.openWebSite(self.path);
                break;
            default:
                break;
        }
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
        });
    }

    setOutOpenType() {
        if (this.fileRule.test(this.el.path)) {
            // 外開資料
            this.outOpenType = OUT_OPEN_TYPE.FILE;
        }
        else if (this.audioRule.test(this.el.path)) {
            // 外開音檔
            this.outOpenType = OUT_OPEN_TYPE.AUDIO;
        }
        else if (this.videoRule.test(this.el.path)) {
            // 外開影片
            this.outOpenType = OUT_OPEN_TYPE.VIDEO;
        }
        else if (this.weblinkRule.test(this.el.path)) {
            // 外開網址
            this.outOpenType = OUT_OPEN_TYPE.WEB_LINK;
        }
        else {
            // 外開資料夾
            this.outOpenType = OUT_OPEN_TYPE.FOLDER;
        }
    }
}